import { Input, Image, Text, View, Tab, MenuSale, Prompt } from 'components';
import Base, { Config } from 'components/saleTool/Base';
import React from 'react';
import styles from './index.module.scss';
import { history } from 'modules/navigator';
import { user } from 'modules/saleTool/store';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Loading } from 'components/Modal';
import copy from 'copy-to-clipboard';
import cx from 'classnames';


interface Order {
  create_time: string;
  status: number;
  name: string;
  phone: string;
  is_pay: number;
  pay_type: number;
  address: string;
  id: number;
  order_goods?: any;
  edsn?: string;
}

interface State {
  orders: Order[];
  page: number;
  status: number | '';
  statusArr: any;
  loading: boolean;
  isEnd: boolean;
  userType: number;    //当前账号身份 1管理员、2销售、3分拣员
  tabCollect: any;
  showModal: boolean;
  edsnName: string;
  edsnCode: string;
  applyId?: number;
  applySta?: number;
  barShow: boolean;
  totalArr?: any;
}

let lock = false;

export default class Main extends Base {
  public config: Config = {
    navigationBarTitleText: '订单列表'
  };

  public state: State = {
    orders:[],
    page:1,
    status: '',    //0待确认，1待审核，2待发货，3已发货
    statusArr: ['待确认','待审核','待发货','已发货'],
    loading: false,
    isEnd: false,
    userType: 0,
    tabCollect: [
      ['全部订单','待确认','待审核','待发货','已发货'],
      ['全部订单','待确认','待审核','待发货','已发货'],
      ['全部订单','待发货','已发货'],
    ],
    showModal:false,
    edsnName: '',
    edsnCode: '',
    barShow:false,
    totalArr: []
  };

  public async didMount() {
    // await this.getUserInfo()
    // await this.getOrders();
     this.getUserInfo()
     this.getOrders();
    this.getTotalNumber()


    // var xmlHttp = new XMLHttpRequest();
    // xmlHttp.open("GET", "https://oa-test.gongji58.com/v1/user",true);
    // xmlHttp.setRequestHeader("token","0ad9e9b8b51f60b97141133ebb552c1b3bdf4ec4cf3e71025646e33223bd319a");
    // xmlHttp.send();

    // var xmlHttp1 = new XMLHttpRequest();
    // xmlHttp1.open("GET", "https://oa-test.gongji58.com/v1/order?page=1",true);
    // xmlHttp1.setRequestHeader("token","0ad9e9b8b51f60b97141133ebb552c1b3bdf4ec4cf3e71025646e33223bd319a");
    // xmlHttp1.send();

    // var xmlHttp2 = new XMLHttpRequest();
    // xmlHttp2.open("GET", "https://oa-test.gongji58.com/v1/order?status=2",true);
    // xmlHttp2.setRequestHeader("token","0ad9e9b8b51f60b97141133ebb552c1b3bdf4ec4cf3e71025646e33223bd319a");
    // xmlHttp2.send();


    let _this = this;
    window.addEventListener('scroll', (e) => {
        _this.handleScroll(e);
    });
  }

  private handleScroll = (e) => {
    // console.log(e)
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    const height = document.body.scrollHeight-window.innerHeight
    // console.log(
    //   scrollTop,
    //   document.body.scrollHeight-window.innerHeight
    // )
    if(height < 0){return;}
    if(scrollTop > height-10 && !this.state.isEnd && !lock){
      console.log("loading")
      lock = true;
      this.setState({
        page: this.state.page+1,
        loading:true
      },
      () => {
        this.getOrders()
      })
    }
  }

  private toAdd = () => {
    history.push('/saleTool/orderAdd')
  }

  private toDetail = (id) => {
    history.push('/saleTool/orderDetail',{id})
  }

  private getUserInfo = async() => {
    const res = await this.apiClient.base.userListInfo()
    // console.log(res);
    if(res && res.status == 10000){
      this.setState({
        userType: res.body.type
        // userType: 3
      })
    }
    
  }

  private getTotalNumber = async() => {
    let res = await this.apiClient.base.orderListInfo({
      status: 2
    })
    if(res && res.status == 10000){
      this.setState({
        totalArr: res.body,
        barShow: true
      })
    }
    // console.log(res)
  }

  private showLoading = () => {
    this.setState({
      loading:true
    })
  }
  private hideLoading = () => {
    this.setState({
      loading:false
    })
  }

  private valueChange = (name,e) => {
    // console.log(name,e.target.value);
    // this.setState({[name]:  e.target.value})
  }
// tabCollect: [
//       ['全部订单','待审核','待发货','已发货'],
//        ''、        1、      2、      3
//       ['全部订单','待确认','待审核','待发货','已发货'],
//        ''、        0、      1、      2、      3
//       ['全部订单','待发货','已发货'],
//        ''、        2、      3
//     ]
// userType: number;    //当前账号身份 1管理员、2销售、3分拣员
  private tabFun = (ind) => {
    const { userType } = this.state;
    let val = ind == 0 ? '' : ind-1;
    if(ind == 0){
      val = ''
    }else if(userType == 1){
      //管理员
      // val = ind
    }else if(userType == 3){
      //分拣员
      val = ind+1
    }
    
    this.setState({
      status: val,
      page: 1,
      orders: [],
      isEnd: false
    },
    () => {
      this.getOrders()
    })
    
  }

  private getOrders = async() => {
    const { page, status } = this.state;
    let data = {}
    this.showLoading()
    if(typeof(status) == "string"){
      data = {
        page
      }
    }else{
      data = {
        page,
        status
      }
    }

    let res = await this.apiClient.base.orderListInfo(data)
    if(!res || res.status != 10000){
      toast.error(res.msg,{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      return;
    }
    if(JSON.stringify(res.body) == "{}"){return;}
    let result = [...this.state.orders,...res.body];

    this.setState({
      orders:result,
      isEnd: res.body.length == 0
    },() => {
      lock = false;
    })
    this.hideLoading()
    // console.log(res,res.body)
  }


  private inputChange = (name,e) => {
    // console.log(name,[name],name.indexOf('.'),e.target.value);

      this.setState({[name]:  e.target.value})
  }

  private promptConfirm = () => {
    const { edsnName, edsnCode, applyId, applySta } = this.state
    // console.log(edsnName, edsnCode);
    if(edsnName.replace(/\s+/g,"") == '' || edsnCode.replace(/\s+/g,"") == ''){
      toast.error("请填写完整",{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      return;
    }
    let edsn = edsnName+"/"+edsnCode
    // console.log(applyId,applySta,edsn)
    this.applySubmit(applyId,applySta,edsn)
    this.promptCancel()
  }

  private promptCancel = () => {
    this.setState({
      showModal: false,
      edsnName: "",
      edsnCode: ""
    })
  }

  private apply = async(id,sta) => {
    // console.log(id,sta)
    if(sta == 3) {
      this.setState({
        showModal: true,
        applyId: id,
        applySta: sta,
      })
      return;
      // const result=await prompt("请填写快递单号");
      // if(!result || result == " "){
      //   toast.error("需填写快递单号",{
      //     position: toast.POSITION.TOP_RIGHT,
      //     autoClose: 1500,
      //     closeButton: false,
      //   })
      //   return;
      // }
      // edsn = result
    }else {
      const result = await confirm("是否确定提交");
      if(!result){return;}
    }
    
    this.applySubmit(id,sta)
  }

  private applySubmit = async(id,sta,edsn='') => {
    // console.log(id,sta,edsn);return;
    this.showLoading()
    let res = await this.apiClient.base.orderEdit({
      id,
      status:sta,
      edsn
    })
    if(res.status == 10000){
      toast.info("提交成功！",{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      this.setState({
        page:1,
        orders: [],
        isEnd: false
      },
      () => {
        this.getOrders()
      })
      
    }else{
      toast.error(res.msg,{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
    }
    this.hideLoading()
  }

  private delete = async(id) => {
    const result = await confirm("是否确定删除");
    if(!result){return;}
    this.showLoading()
    let res = await this.apiClient.base.orderDelete({
      id
    })
    if(res.status == 10000){
      toast.info("删除成功！",{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      this.setState({
        page:1,
        orders: [],
        isEnd: false
      },
      () => {
        this.getOrders()
      })
      
    }else{
      toast.error(res.msg,{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
    }
    this.hideLoading()
  }

  private copyFun = (str) => {
    if(typeof(str) == 'object') {
      let goods = str;
      let string = ''
      goods.map((opt,ind) => {
        string+= opt.goods_type == 1 ? "标准版×": "增强版×";
        string+= opt.goods_num;
      })
      str = string
    }

    if(copy(str)){
      toast.info("复制成功！",{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
    }else{
      toast.error("复制失败！请手动复制",{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
    }
  }

  private edit = (id) => {
    history.push('/saleTool/orderAdd',{id})
  }

  private toggleBar = () => {
    this.setState({
      barShow:!this.state.barShow
    })
  }

  public render() {
    const { orders, statusArr, loading, userType, tabCollect, showModal, edsnName, edsnCode, totalArr } = this.state;

    return (
      <View className={styles.container}>
        <Loading isOpen={loading} />
        <ToastContainer className={styles.ToastContainer}/>
        <Prompt isOpen={showModal} className={styles.modal} onCancel={this.promptCancel} onConfirm={this.promptConfirm}>
          <View className={styles.modalBox}>
            <View className={styles.modalLis}>
              <View className={styles.modalTit}>输入快递公司名称</View>
              <View className={styles.modalMain}>
                <Input
                  value={edsnName}
                  name="edsnName"
                  className={styles.input}
                  placeholder="请填写"
                  valueChange={this.inputChange}
                />
              </View>
            </View>
            <View className={styles.modalLis}>
              <View className={styles.modalTit}>输入快递单号</View>
              <View className={styles.modalMain}>
                <Input
                  value={edsnCode}
                  name="edsnCode"
                  className={styles.input}
                  placeholder="请填写"
                  valueChange={this.inputChange}
                />
              </View>
            </View>
          </View>
        </Prompt>
        <MenuSale opt={[
            {
              title:"订单管理",
              ico:this.assets.saleTool.menuIco_aa,
              selectIco:this.assets.saleTool.menuIco_ab,
              url:'/saleTool/main'
            },
            {
              title:"账户管理",
              ico:this.assets.saleTool.menuIco_ba,
              selectIco:this.assets.saleTool.menuIco_bb,
              url:'/saleTool/user'
            }
          ]} 
          current={0}
        />
        <Tab 
          opt={tabCollect[userType-1]}
          onClick={this.tabFun}
          className={styles.tabBox}
        />
        {
          (userType == 1 || userType == 2) && (<View className={styles.addBtn} onClick={this.toAdd}>+新增订单</View>)
        }

        {userType != 2 && (
          <View className={cx(styles.barBox,this.state.barShow && styles.active)}>
            <View className={cx(styles.barBtn)} onClick={this.toggleBar}>
              <Text className={styles.barBtnLine} />
            </View>
            <View className={cx(styles.barInner)}>
              <Text className={styles.barTxt1}>待发货统计:</Text>
              {totalArr && totalArr.map((opt,ind) => {
                return(<Text className={styles.barTxt} key={ind}>{opt.goods_type == 1 ? "标准版 ":"增强版 "}×{opt.goods_num}</Text>)
              })}
            </View>
          </View>
        )}
        
        
        <View className={styles.orders}>
          {orders.length < 1 && (
            <Text className={styles.empty}>暂无数据...</Text>
          )}
          {orders.map((option, index) => {
            return (
              <View className={styles.lis} key={index}>
                <View className={styles.lis_t} onClick={this.toDetail.bind(null,option.id)}>
                  <Text className={styles.lis_t_l}>{option.create_time}</Text>
                  <Text className={styles.lis_t_r}>{statusArr[option.status]}</Text>
                </View>
                <View className={styles.lis_m} onClick={this.toDetail.bind(null,option.id)}>
                  <View className={styles.lis_m_t}>
                    <Text className={styles.lis_name}>{option.name}</Text>
                    <Text className={styles.lis_phone}>{option.phone}</Text>
                    <Text className={styles.lis_price}>
                      {option.pay_type == 1?"微信转账":(option.pay_type == 2?"微店下单":"到付")}
                    </Text>
                  </View>
                  <View className={styles.lis_m_b}>
                    <Text className={styles.lis_address}>{option.address}</Text>
                    <Text className={styles.lis_count}>
                      {option.order_goods && option.order_goods.map((opt,ind) => {
                        return (
                          <Text key={ind}>{opt.goods_type == 1 ? "标准": "增强"}<small>×</small>{opt.goods_num}</Text>
                        )
                      })}
                    </Text>
                    
                  </View>
                </View>
                {option.status != 0 && (
                  <View className={styles.copyBox}>
                    <Text className={styles.copy} onClick={this.copyFun.bind(null,option.name+"，"+option.phone+"，"+option.address+"；")}>复制收货信息</Text>
                    {option.edsn != '' && 
                      <Text className={styles.copy} onClick={this.copyFun.bind(null,option.edsn)}>复制快递单号</Text>
                    }
                    {option.order_goods && 
                      <Text className={styles.copy} onClick={this.copyFun.bind(null,option.order_goods)}>复制型号数量</Text>
                    }
                  </View>
                )}
                {userType == 1 && (
                  <View className={styles.lis_b}>
                    <View className={styles.lis_b_l} onClick={this.delete.bind(this,option.id)}>
                      删除订单
                    </View>
                    <View className={styles.lis_b_r}>
                      <Text className={styles.btn_blue} onClick={this.edit.bind(this,option.id)}>修改</Text>
                      {option.status == 0 && (
                         <Text className={styles.btn_orange} onClick={this.apply.bind(this,option.id,1)}>提交审核</Text>
                      )}
                      {option.status == 1 && (
                         <Text className={styles.btn_orange} onClick={this.apply.bind(this,option.id,2)}>通过审核</Text>
                      )}
                      {option.status == 2 && (
                         <Text className={styles.btn_orange} onClick={this.apply.bind(this,option.id,3)}>快递发货</Text>
                      )}
                    </View>
                  </View>
                )}
                {userType == 2 && option.status == 0 && (
                  <View className={styles.lis_b}>
                    <View className={styles.lis_b_l} onClick={this.delete.bind(this,option.id)}>
                      删除订单
                    </View>
                    <View className={styles.lis_b_r}>
                      <Text className={styles.btn_blue} onClick={this.edit.bind(this,option.id)}>修改</Text>
                      <Text className={styles.btn_orange} onClick={this.apply.bind(this,option.id,1)}>提交审核</Text>
                    </View>
                  </View>
                )}
                {userType == 3 && (
                  <View className={styles.lis_b}>
                    <View className={styles.lis_b_l}>
                      
                    </View>
                    <View className={styles.lis_b_r}>
                      {option.status == 2 && (
                         <Text className={styles.btn_orange} onClick={this.apply.bind(this,option.id,3)}>快递发货</Text>
                      )}
                    </View>
                  </View>
                )}
              </View>
            )
          })}
          
        </View>
        
      </View>
    );
  }
}
